export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const normalizeTaxCategoryId = (taxCategoryId) => {
  if (taxCategoryId == null) return null;
  return typeof taxCategoryId === "string" && !taxCategoryId.trim()
    ? null
    : taxCategoryId;
};

export const buildMenuSizeOptions = (options = [], menuId) => options.map((option) => ({
  ...option,
  price: Number.parseFloat(option.price) || 0,
  menuId,
  // The API owns IDs for new portions. A generated client ID makes the API
  // interpret a new row as an update and the row is then silently skipped.
  sizeOptionId: option.sizeOptionId || EMPTY_GUID
}));
